import React from "react";
import ManagePrimaryOrder from "./ManagePrimaryOrder";
import ManagePrimaryOrderOMSV2 from "./ManagePrimaryOrderOMSV2";

const ManagePrimaryOrderOMSContainer = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  
  const managePrimaryOrderVersion =  ConfigDictionary?.enableManagePrimaryOrderOmsV2 ?? false;

  return managePrimaryOrderVersion ? (
    <ManagePrimaryOrderOMSV2 />
  ) : (
    <ManagePrimaryOrder />
  );
};

export default ManagePrimaryOrderOMSContainer;
